import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import authService from "@/services/auth.service";
import { msalInstance } from "@/authConfig";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "CalculationList",
    component: () => import("@/views/CalculationListView.vue"),
    meta: {
      requireAuth: true,
      requireAdmin: true,
    },
  },
  {
    path: "/calculation",
    name: "Calculation",
    props: true,
    component: () => import("@/views/CalculationView.vue"),
    meta: {
      requireAuth: true,
      requireAdmin: true,
    },
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    props: true,
    component: () => import("@/views/Unauthorized.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/calculator",
    name: "Calculator",
    component: () => import("@/views/CalculatorView.vue"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/invoice",
    name: "Invoice",
    component: () => import("@/views/InvoiceView.vue"),
    meta: {
      requireAuth: true,
      requireAdmin: true,
    },
  },
  {
    path: "/contingent-offset",
    name: "Offset",
    component: () => import("@/views/ContingentOffsetView.vue"),
    meta: {
      requireAuth: true,
      requireAdmin: true,
    },
  },
  {
    path: "/contingent",
    name: "Contingent",
    component: () => import("@/views/ContingentView.vue"),
    meta: {
      requireAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, _, next) => {
  await msalInstance.handleRedirectPromise();
  const accounts = msalInstance.getAllAccounts();
  const isAuthenticated = accounts.length > 0;
  if (!isAuthenticated) {
    await authService.login();
  }
  const isAdmin = await authService.isAdmin();
  const isUser = await authService.isUser();

  if (isAuthenticated && isAdmin) {
    next();
  } else if (isUser && !to.matched.some((record) => record.meta.requireAdmin)) {
    next();
  } else if (isAuthenticated) {
    if (to.path === "/unauthorized") {
      next();
    } else if (isUser) {
      next({
        path: "/calculator",
        replace: true,
      });
    } else {
      next({
        path: "/unauthorized",
        replace: true,
      });
    }
  } else if (to.matched.some((record) => record.meta.requireAuth)) {
    await authService.login();
  } else {
    next();
  }
});

export default router;
